import PublicLayout from "../../layouts/PublicLayout";

const WhoIsShadow = () => {
  return (
    <PublicLayout>
      <div className='bg-aboutImage bg-no-repeat bg-cover h-full w-full bg-center'>
        <div className="w-full h-full bg-primary opacity-50 absolute -z-0"></div>
        <div className='relative z-10 xl:h-screen flex flex-col py-4 xl:py-0 justify-center items-center'>
          <div className='flex flex-col justify-center items-center gap-6 lg:gap-32'>
            <div className='flex flex-col gap-4 text-center justify-center items-center'>
              <h1 className='text-white font-bold text-xl lg:text-4xl'>
                {" "}
                نبذه عن ظل
              </h1>
              <p className='text-white font-light w-1/2 text-lg lg:text-2xl'>
                مركز يُعنى بتمكين ذوي الإعاقة ليصبحوا قادرين على العيش
                بإستقلالية وتأهيلهم تأهيل تعليمي، تربوي ومهني وتقديم
                الخدمات المساندة لهم
              </p>
            </div>
            <div className='flex flex-col gap-4 text-center justify-center items-center'>
              <h1 className='text-white font-bold text-xl lg:text-4xl'>
                {" "}
                الرؤية
              </h1>
              <p className='text-white font-light w-1/2 text-lg lg:text-2xl'>
                ان يكون مركز ظل الرائد الأول في تقديم الخدمات للأفراد من ذوي
                الاحتياجات الخاصة التي تساهم في اندماجهم مع المجتمع وتطوير
                مهاراتهم السلوكية في بيئة علاجية متكاملة.{" "}
              </p>
            </div>
          </div>

        </div>
      </div>
    </PublicLayout>
  );
};

export default WhoIsShadow;
